import React from 'react';
import styled from 'styled-components';
import BSGLOGO from '../../assets/icons/BSG.png';
import NewFooter from '../../components/Footer/NewFooter';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const HeaderContainer = styled.header`
  background-color: #53a8a0;
  display: flex;
  align-items: center;
  display: flex;
  height: 80px;
  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
`;
const Logo = styled.img`
  width: 50px;
  height: 50px;
`;
const LogoContainer = styled.div`
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: #e9e9e9;
`;

const ContainerIn = styled.div`
  width: 80%;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 90%;
  }
`;

const AboutHeading = styled.h2`
  text-align: center;
  margin-top: 40px;
  font-size: 29px;
  font-family: sans-serif;
`;

const AboutSubHeading = styled.h4`
  font-size: 20px;
  margin-top: 35px;
  position: relative;
  display: inline-block;
  color: #479081;
  margin: 0;
`;

const ParagraphContent = styled.p`
  font-size: 16px;
  line-height: 25px;
`;
const NoticeText = styled.p`
  text-align: center;
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
`;

const TermsOfUse = () => {
  const navigate = useNavigate();
  const TITLE = 'Terms of use - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <HeaderContainer>
        <LogoContainer onClick={() => navigate('/login')}>
          <Logo src={BSGLOGO} alt="Logo" />
        </LogoContainer>
      </HeaderContainer>
      <Container>
        <ContainerIn>
          <AboutHeading>Terms of Use</AboutHeading>
          <div />
          <AboutSubHeading>Terms of Use</AboutSubHeading>
          <ParagraphContent>
            The use of this website www.contribution.bharatsokagakkai.org
            constitutes an agreement with the following terms and conditions:
          </ParagraphContent>
          <ParagraphContent>
            This website is maintained by the Bharat Soka Gakkai Headquarters as
            a facility to those who may choose to access the Site (“Users”).
            These Terms of Use govern your access to and use of our website,
            including any content, functionality and services offered on or
            through our website, and the use of any personal data that you
            choose to submit.
          </ParagraphContent>
          <ParagraphContent>
            Each time you use this website, you accept and agree to be bound and
            abide by these Terms of Use and our Privacy Policy, incorporated
            herein. If you do not agree to these Terms of Use or the Privacy
            Policy incorporated herein, please do not access or use the website.
          </ParagraphContent>
          <ParagraphContent>
            We reserve the right to close or amend this website and withdraw any
            service or material we provide on the website, at our sole
            discretion without notice. We will not be liable, if, for any reason
            all or any part of the website is unavailable at any time or for any
            period. From time to time, we may restrict the access to some parts
            of the website, or the entire website, to Users, including
            registered Users.
          </ParagraphContent>
          <ParagraphContent>
            You are responsible for: Making all arrangements necessary for you
            to have access to the website. Ensuring that all persons who access
            the website through your internet connection are aware of these
            Terms of Use and comply with them.
          </ParagraphContent>
          <ParagraphContent>
            Bharat Soka Gakkai hereby grants permission to Users to visit the
            Site and to download and copy the information and materials
            (collectively, “Materials”) from the Site for the User’s personal,
            non-commercial use, without any right to sell or redistribute them
            or to compile or create derivative works therefrom, subject to the
            terms and conditions outlined below, and also subject to more
            specific restrictions that may apply to specific part or parts of
            the Materials within this Site.
          </ParagraphContent>
          <ParagraphContent>
            Unless expressly stated otherwise, the findings, interpretations and
            conclusions expressed in the Materials on this Site are those of
            Bharat Soka Gakkai consultants and advisers, who prepared the work
            and do not necessarily represent the views of the Bharat Soka
            Gakkai, its affiliated organizations, or its membership.
          </ParagraphContent>
          <ParagraphContent>
            If you choose, or are provided with, a user name, password or other
            identifier, or any other piece of information (“User Data”) as part
            of our security procedures, you must treat such information as
            confidential, and you must not disclose it to any other person or
            entity. You also acknowledge that your account is personal to you
            and agree not to provide to any other person, with access to this
            website or portions of it using your User Data. You agree to notify
            us immediately of any unauthorized access to or use of your User
            Data or any other breach of security. You also agree to ensure that
            you exit from your account at the end of each session. You should
            use particular caution when accessing your account from a public or
            shared computer so that others are not able to view or record your
            User Data or other personal information.
          </ParagraphContent>
          <ParagraphContent>
            We have the right to disable any User Data, whether chosen by you or
            provided by us, at any time in our sole discretion if, in our
            opinion, you have violated any provision of these Terms of Use or we
            become aware of a potential breach of security through the use of
            your User Data.
          </ParagraphContent>
          <ParagraphContent>
            All matters relating to the website and these Terms of Use and any
            dispute or claim arising therefrom or related thereto (in each case,
            including non-contractual disputes or claims), shall be governed by
            and construed in accordance with the laws of India and shall be
            instituted exclusively under the Courts of New Delhi, although we
            retain the right to bring any suit, action or proceeding against you
            for breach of these Terms of Use in your country/state of residence
            or any other relevant country if appropriate. You waive any and all
            objections to the exercise of jurisdiction over you by such courts
            and to venue in such courts.
          </ParagraphContent>
          <AboutSubHeading>Intellectual Property Rights</AboutSubHeading>
          <ParagraphContent>
            The copyright to this Site and the content of this Site, including
            and without limitation, all images, texts and designs, trademarks,
            trade dress, logos and all intellectual property rights in the
            website, are reserved by the Bharat Soka Gakkai, except where
            copyright ownership is otherwise expressly stated.
          </ParagraphContent>
          <ParagraphContent>
            Users shall not use this Site or any information therein in
            violation of any rights provided by any law, policy, rule or
            regulation of any country and region or for any illegal activity or
            any activity prohibited by any law, policy, rule or regulation of
            any country and region. Bharat Soka Gakkai is not responsible for
            such illegal use of the copyrighted Materials.
          </ParagraphContent>
          <AboutSubHeading>Privacy Policy</AboutSubHeading>
          <ParagraphContent>
            By accessing this website, certain information about the User, such
            as Internet protocol (IP) addresses, navigation through the Site,
            the software used and the time spent, along with any other
            information available to the administrator of this Site, will be
            stored on the Bharat Soka Gakkai servers. The information will be
            used internally only for website maintenance purposes and traffic
            and statistical analysis. If the User voluntarily provides unique
            identifying information, such as name, address and other information
            on this Site, such information will be used only to the extent
            expressly agreed by the User for originally intended purposes of use
            and will not be published for any other purpose unless otherwise
            specified.
          </ParagraphContent>
          <ParagraphContent>
            Bharat Soka Gakkai maintains reasonable safeguards in an effort to
            ensure the security, integrity and privacy of the personal
            information we collect. Unfortunately, the transmission of
            information via the internet is not completely secure. Although we
            do our best to protect your personal information, we cannot
            guarantee and assume responsibility for the security of your
            personal information transmitted to our website. Any transmission of
            personal information is at your own risk. We are not responsible for
            circumvention of any privacy settings or security measures contained
            on the website.
          </ParagraphContent>
          <AboutSubHeading>Disclaimers</AboutSubHeading>
          <ParagraphContent>
            Materials provided on this Site are provided “as is” without
            warranty of any kind, either express or implied, including and
            without limitation, warranties of merchantability, fitness for a
            particular purpose and non-infringement. Bharat Soka Gakkai
            specifically does not make any warranties or representations as to
            the accuracy or completeness of any such Materials. Bharat Soka
            Gakkai periodically adds, changes, improves or updates the Materials
            on this Site without notice. Under no circumstances shall Bharat
            Soka Gakkai be liable for any loss, damage, liability or expense
            incurred or suffered that is claimed to have resulted from the use
            of this Site, including and without limitation, any fault, error,
            omission, interruption or delay with respect thereto.
          </ParagraphContent>
          <ParagraphContent>
            The use of this Site is at the User’s sole risk. Under no
            circumstances, including but not limited to, negligence or omission,
            shall Bharat Soka Gakkai or its affiliates be liable for any direct,
            indirect, incidental, special or consequential damages, even if
            Bharat Soka Gakkai has been advised of the possibility of such
            damages.
          </ParagraphContent>
          <ParagraphContent>
            Neither Bharat Soka Gakkai nor its affiliates, nor any of its
            respective agents, employees, information providers or content
            providers, shall be liable to any User or anyone else, for any
            inaccuracy, error, omission, interruption, deletion, defect,
            alteration of or use of any content herein, or for its timeliness or
            completeness, nor shall they be liable for any failure of
            performance, computer virus or communication line failure,
            regardless of cause, or for any damages resulting therefrom.
          </ParagraphContent>
          <ParagraphContent>
            As a condition of use of this Site, the User agrees to indemnify
            Bharat Soka Gakkai and its affiliates from and against any and all
            actions, claims, losses, damages, liabilities and expenses
            (including reasonable legal fees) arising out of the User’s use of
            this Site, including and without limitation, any claims alleging
            facts that if true, would constitute a breach by the User of these
            Terms and Conditions. If the User is dissatisfied with any part or
            parts of the Materials on this Site or with any of its Terms and
            Conditions of Use, the User’s sole and exclusive remedy is to
            discontinue using the Site.
          </ParagraphContent>
          <ParagraphContent>
            This Site may contain links and references to third-party websites.
            The linked sites are not under the control of Bharat Soka Gakkai,
            and Bharat Soka Gakkai is not responsible for the content of any
            linked site, any link contained in a linked site or the privacy
            policy of any linked site. Bharat Soka Gakkai provides these links
            only as a facility and for the convenience of the Users, and the
            inclusion of a link or reference does not imply the endorsement of
            the linked site by Bharat Soka Gakkai.
          </ParagraphContent>
          <Box sx={{ marginTop: '100px' }}>
            <NoticeText>
              “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR
              MAKING CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES
              CONTRIBUTION THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR
              CONTRIBUTION.”
            </NoticeText>
          </Box>
        </ContainerIn>
      </Container>
      <NewFooter />
    </>
  );
};

export default TermsOfUse;
